/* Harucake Theme JS */

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     CALENDAR
     ───────────────────────────────────────── */
  const OPEN_DAYS = [2, 3, 4, 5, 6]; // Tue-Sat (0=Sun)
  const MAX_DAYS_AHEAD = 30;
  const MIN_DAYS_AHEAD = 2; // at least 2 days notice

  // -- Standard cake one-off reopen dates ------------------------------------
  const STANDARD_FORCE_OPEN_DATES = new Set([]);

  const TIMESLOTS = {
    weekday: ['12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM'],
    weekend: ['12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM']
  };

  const PICKUP_SLOT_DISPLAY_BY_DATE = {};

  const FULL_SLOTS_BY_DATE = {
  };

  function isSlotFullOnDate(ymd, slot) {
    return !!(FULL_SLOTS_BY_DATE[ymd] && FULL_SLOTS_BY_DATE[ymd].indexOf(slot) !== -1);
  }

  const STANDARD_FULL_SLOTS_BY_DATE = {};

  function isStandardSlotFullOnDate(ymd, slot) {
    return !!(STANDARD_FULL_SLOTS_BY_DATE[ymd] && STANDARD_FULL_SLOTS_BY_DATE[ymd].indexOf(slot) !== -1);
  }

  // Assorted/CYO minimum pickup times by weekday:
//   Tue–Fri: 12:00 PM
//   Sat: 1:00 PM
// Sun/Mon stay closed via the existing OPEN_DAYS guard.
  const ASSORTED_CAKE_MIN_MINUTES_WEEKDAY = 720; // 12:00 PM
  const ASSORTED_CAKE_MIN_MINUTES_SAT     = 780; // 1:00 PM

  function assortedMinMinutesForDate(date) {
    return (date && typeof date.getDay === 'function' && date.getDay() === 6)
      ? ASSORTED_CAKE_MIN_MINUTES_SAT
      : ASSORTED_CAKE_MIN_MINUTES_WEEKDAY;
}

  function timeToMinutes(slot) {
    const m = String(slot).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!m) return 0;
    let h = parseInt(m[1], 10);
    const min = parseInt(m[2], 10);
    const mer = m[3].toUpperCase();
    if (mer === 'PM' && h !== 12) h += 12;
    if (mer === 'AM' && h === 12) h = 0;
    return h * 60 + min;
  }

  function isAssortedCakeProduct() {
    const form = document.getElementById('product-form');
    if (!form) return false;
    const handle = (form.dataset.productHandle || '').toLowerCase();
    const title  = (form.dataset.productTitle  || '').toLowerCase();
    return handle.includes('assorted') || title.includes('assorted cake');
  }

  function filterSlotsForAssorted(slots, date) {
    if (!isAssortedCakeProduct()) return slots;
    const minMinutes = assortedMinMinutesForDate(date);
    return slots.filter(function(slot) {
      return timeToMinutes(slot) >= minMinutes;
    });
  }

  function isSameDayProduct(form) {
    if (!form) return false;
    const handle = (form.dataset.productHandle || '').toLowerCase();
    const title = (form.dataset.productTitle || '').toLowerCase();
    const sameDayFlag = String(form.dataset.sameDay || '').toLowerCase();
    const path = window.location.pathname.toLowerCase();
    return (
      sameDayFlag === 'true' ||
      handle.indexOf('same-day') !== -1 ||
      handle.indexOf('sameday') !== -1 ||
      title.indexOf('same day') !== -1 ||
      path.indexOf('/products/same-day') !== -1 ||
      path.indexOf('/products/sameday') !== -1
    );
  }

  function getTodayYMDInLosAngeles() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    const year = parts.find(function(p) { return p.type === 'year'; }).value;
    const month = parts.find(function(p) { return p.type === 'month'; }).value;
    const day = parts.find(function(p) { return p.type === 'day'; }).value;
    return year + '-' + month + '-' + day;
  }

  function setLineItemProperty(form, name, value) {
    if (!form) return;
    const inputName = 'properties[' + name + ']';
    let input = form.querySelector('input[name="' + inputName + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      form.appendChild(input);
    }
    input.value = value;
  }

  function prepareSameDayPickup(form) {
    if (!form) return;
    setLineItemProperty(form, 'Pickup Date', getTodayYMDInLosAngeles());
    setLineItemProperty(form, 'Pickup Time', 'Same-day pickup starting at 1:00 PM');
    setLineItemProperty(form, 'Order Type', 'Same-Day Pickup');
  }

  function getToday() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function addDays(date, n) {
    const d = new Date(date);
    d.setDate(d.getDate() + n);
    return d;
  }

  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() &&
           a.getMonth() === b.getMonth() &&
           a.getDate() === b.getDate();
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function formatYMD(d) {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function parseDisplayDate(value) {
    if (!value) return null;
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) return null;
    parsed.setHours(0, 0, 0, 0);
    return parsed;
  }

  // Parse a date string like "Mon, May 25, 2026" robustly (no timezone ambiguity)
  function parseEditDateString(str) {
    if (!str) return null;
    var MONTHS = {jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11};
    var m = str.match(/([A-Za-z]+)\s+(\d{1,2}),?\s+(\d{4})/);
    if (!m) return null;
    var mo = MONTHS[m[1].toLowerCase().substring(0, 3)];
    if (mo === undefined) return null;
    var d = new Date(parseInt(m[3], 10), mo, parseInt(m[2], 10));
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function getBlackoutDates() {
    const source = document.getElementById('pickup-blackout-dates');
    const dates = new Set();
    if (!source) return dates;
    source.textContent
      .split(/\r?\n/)
      .map(function(v) { return v.trim(); })
      .filter(Boolean)
      .forEach(function(v) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(v)) dates.add(v);
      });
    return dates;
  }

  function isSelectable(d, blackoutDates, forceOpenDates) {
    if (!blackoutDates) blackoutDates = new Set();
    if (!forceOpenDates) forceOpenDates = new Set();
    const today = getToday();
    const earliest = addDays(today, MIN_DAYS_AHEAD);
    const latest = addDays(today, MAX_DAYS_AHEAD);
    const ymd = formatYMD(d);
    const isForceOpenDate = forceOpenDates.has(ymd);
    return (
      d >= today &&
      d <= latest &&
      (isForceOpenDate || d >= earliest) &&
      (OPEN_DAYS.includes(d.getDay()) || isForceOpenDate) &&
      (isForceOpenDate || !blackoutDates.has(ymd))
    );
  }

  const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  window.HaruCalendar = {
    selectedDate: null,
    viewYear: null,
    viewMonth: null,
    blackoutDates: new Set(),
    forceOpenDates: new Set(),
    wrap: null,

    init: function(wrapSelector, options) {
      if (!options) options = {};
      this.wrap = document.querySelector(wrapSelector);
      if (!this.wrap) return;
      this.blackoutDates = options.blackoutDates || new Set();
      this.forceOpenDates = options.forceOpenDates || new Set();
      const today = getToday();
      this.viewYear = today.getFullYear();
      this.viewMonth = today.getMonth();
      const self = this;
      this.wrap.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-cal-nav]');
        if (btn) {
          const dir = parseInt(btn.dataset.calNav, 10);
          self.viewMonth += dir;
          if (self.viewMonth > 11) { self.viewMonth = 0; self.viewYear++; }
          if (self.viewMonth < 0) { self.viewMonth = 11; self.viewYear--; }
          self.render();
          return;
        }
        const day = e.target.closest('[data-cal-date]');
        if (day && !day.classList.contains('cal-day--unavailable')) {
          self.selectedDate = new Date(parseInt(day.dataset.calDate, 10));
          self.selectedDate.setHours(0, 0, 0, 0);
          self.render();
          self.onSelect(self.selectedDate);
        }
      });
      this.render();
    },

    render: function() {
      if (this.selectedDate && !isSelectable(this.selectedDate, this.blackoutDates, this.forceOpenDates)) {
        this.selectedDate = null;
        this.onClear();
      }
      const today = getToday();
      const earliest = addDays(today, MIN_DAYS_AHEAD);
      const latest = addDays(today, MAX_DAYS_AHEAD);
      const firstOfMonth = new Date(this.viewYear, this.viewMonth, 1);
      const lastOfMonth  = new Date(this.viewYear, this.viewMonth + 1, 0);
      const prevDisabled = lastOfMonth < earliest;
      const nextDisabled = firstOfMonth > latest;
      let html = '<div class="cal-header">' +
        '<button class="cal-nav" data-cal-nav="-1"' + (prevDisabled ? ' disabled' : '') + '>&#8592;</button>' +
        '<span class="cal-title">' + MONTH_NAMES[this.viewMonth] + ' ' + this.viewYear + '</span>' +
        '<button class="cal-nav" data-cal-nav="1"' + (nextDisabled ? ' disabled' : '') + '>&#8594;</button>' +
        '</div><div class="cal-grid">' +
        '<div class="cal-dow">Su</div><div class="cal-dow">Mo</div><div class="cal-dow">Tu</div>' +
        '<div class="cal-dow">We</div><div class="cal-dow">Th</div><div class="cal-dow">Fr</div>' +
        '<div class="cal-dow">Sa</div>';
      const firstDay = new Date(this.viewYear, this.viewMonth, 1).getDay();
      const daysInMonth = new Date(this.viewYear, this.viewMonth + 1, 0).getDate();
      const self = this;
      for (let i = 0; i < firstDay; i++) {
        html += '<div class="cal-day cal-day--empty"></div>';
      }
      for (let d = 1; d <= daysInMonth; d++) {
        const date = new Date(self.viewYear, self.viewMonth, d);
        date.setHours(0, 0, 0, 0);
        const selectable = isSelectable(date, self.blackoutDates, self.forceOpenDates);
        const selected = self.selectedDate && sameDay(date, self.selectedDate);
        const cls = 'cal-day' +
          (!selectable ? ' cal-day--unavailable' : '') +
          (selected ? ' cal-day--selected' : '');
        html += '<div class="' + cls + '"' +
          (selectable ? ' data-cal-date="' + date.getTime() + '"' : '') +
          '>' + d + '</div>';
      }
      html += '</div>';
      this.wrap.innerHTML = html;
    },

    onSelect: function(date) {},
    onClear: function() {}
  };

  /* ─────────────────────────────────────────
     SAME-DAY LETTERING CUTOFF
     ───────────────────────────────────────── */
  // -- TEMPORARY: dates on which same-day writing is fully unavailable --------
  // Add 'YYYY-MM-DD' strings (LA time) to disable same-day board lettering
  // for that day only. REMOVE the entry the next day to restore normal flow.
  // The 2:00 PM same-day cutoff below still applies on any day NOT listed here.
  const SAME_DAY_WRITING_DISABLED_DATES = new Set([
    '2026-05-29' // Fri 2026-05-29: lettering staff leaving early — remove tomorrow
  ]);
  function isSameDayWritingDisabledToday() {
    return SAME_DAY_WRITING_DISABLED_DATES.has(getTodayYMDInLosAngeles());
  }

  function isAfterLetteringCutoff() {
    var laHour = parseInt(new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      hour: 'numeric',
      hour12: false
    }).format(new Date()), 10);
    return laHour >= 14;
  }

  /* ─────────────────────────────────────────
     PRODUCT PAGE
     ───────────────────────────────────────── */
  function initProductPage() {
    const form = document.getElementById('product-form');
    if (!form) return;

    const blackoutDates = getBlackoutDates();
    const sizeCards = document.querySelectorAll('.size-card');
    const sizeInput = document.getElementById('size-input');
    const priceDisplay = document.getElementById('hc-selected-price');
    const variantInput = document.getElementById('variant-id');
    let selectedSize = sizeCards[0] ? sizeCards[0].dataset.size : null;
    let writingEnabled = false;
    let qty = 1;
    function getActiveCard() { return document.querySelector('.size-card--active'); }
    function getBasePrice() {
      var card = getActiveCard();
      if (!card) return 0;
      return parseFloat((writingEnabled ? card.dataset.yesPrice : card.dataset.noPrice) || 0);
    }
    function calcTotal() { return getBasePrice() * qty; }
    function updatePrice() { if (priceDisplay) priceDisplay.textContent = '$' + calcTotal().toFixed(2); }
    function updateVariant() {
      var card = getActiveCard();
      if (!card || !variantInput) return;
      var vid = writingEnabled ? card.dataset.yesVariantId : card.dataset.noVariantId;
      if (vid) variantInput.value = vid;
      var writingFlag = document.getElementById('writing-flag');
      if (writingFlag) writingFlag.value = writingEnabled ? 'Yes (+$10)' : 'No';
    }
    sizeCards.forEach(function(card) {
      card.addEventListener('click', function() {
        sizeCards.forEach(function(c) { c.classList.remove('size-card--active'); });
        card.classList.add('size-card--active');
        selectedSize = card.dataset.size;
        if (sizeInput) sizeInput.value = selectedSize;
        updateVariant();
        updatePrice();
      });
    });
    if (sizeCards[0]) { sizeCards[0].classList.add('size-card--active'); if (sizeInput) sizeInput.value = selectedSize; }
    const writingToggle = document.getElementById('writing-toggle');
    const writingField  = document.getElementById('writing-field');
    const writingInput  = document.getElementById('writing-text');
    if (writingToggle) {
      writingToggle.addEventListener('change', function() {
        writingEnabled = writingToggle.checked;
        if (writingField) { writingField.style.display = writingEnabled ? 'block' : 'none'; }
        updateVariant();
        updatePrice();
      });
    }
    if (writingInput) {
      writingInput.addEventListener('input', function() {
        const counter = document.getElementById('char-count');
        if (counter) counter.textContent = writingInput.value.length;
      });
    }
    const isSameDay = isSameDayProduct(form);
    // Same-day board lettering: grey-out at/after 2 PM LA time — keep visible but disabled.
    // Also grey-out for any date listed in SAME_DAY_WRITING_DISABLED_DATES (temporary today-only block).
    if (isSameDay && writingToggle) {
      if (isAfterLetteringCutoff() || isSameDayWritingDisabledToday()) {
        var letteringSection = writingToggle.closest('.option-section') || writingToggle.parentNode;
        if (letteringSection) {
          letteringSection.style.opacity = '0.45';
          letteringSection.style.pointerEvents = 'none';
        }
        writingToggle.disabled = true;
        writingToggle.checked = false;
        writingEnabled = false;
        var cutoffMsg = document.createElement('p');
        cutoffMsg.style.cssText = 'font-size:13px;color:#8e2525;background:#fdf4f4;border:1px solid #f0d0d0;border-radius:6px;padding:8px 14px;margin-bottom:16px;line-height:1.5;letter-spacing:.01em;';
        cutoffMsg.textContent = isSameDayWritingDisabledToday()
          ? 'Same-day writing is unavailable today.'
          : 'Same-day board lettering is available until 2:00 PM only.';
        if (letteringSection && letteringSection.parentNode) {
          letteringSection.parentNode.insertBefore(cutoffMsg, letteringSection);
        }
      }
    }
    const qtyDisplay = document.getElementById('qty-display');
    const qtyMinus   = document.getElementById('qty-minus');
    const qtyPlus    = document.getElementById('qty-plus');
    const qtyInput   = document.getElementById('qty-input');
    function updateQty(val) {
      qty = Math.max(1, val);
      if (qtyDisplay) qtyDisplay.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      updatePrice();
    }
    if (qtyMinus) { qtyMinus.addEventListener('click', function() { updateQty(qty - 1); }); }
    if (qtyPlus)  { qtyPlus.addEventListener('click',  function() { updateQty(qty + 1); }); }
    const dateInput       = document.getElementById('date-input');
    const dateDisplay     = document.getElementById('selected-date-display');
    const timeInput       = document.getElementById('time-input');
    const timeslotWrap    = document.getElementById('timeslot-wrap');
    const timeslotSection = document.getElementById('timeslot-section');
    const productForceOpenDates = !isSameDay ? STANDARD_FORCE_OPEN_DATES : new Set();
    function clearTimeslotUrgencyNote() {
      if (!timeslotSection) return;
      const existingNote = timeslotSection.querySelector('.hc-timeslot-urgency');
      if (existingNote) existingNote.remove();
    }
    function clearTimeslots() {
      if (timeslotWrap) timeslotWrap.innerHTML = '';
      if (timeslotSection) timeslotSection.style.display = 'none';
      if (timeInput) timeInput.value = '';
      clearTimeslotUrgencyNote();
    }
    function isTimeFullForCurrentProduct(dateYMD, slot) {
      if (isSlotFullOnDate(dateYMD, slot)) return true;
      if (isStandardSlotFullOnDate(dateYMD, slot)) return true;
      return false;
    }
    function getSlotsForDate(date) {
      const dateYMD = formatYMD(date);
      const day = date.getDay();
      if (PICKUP_SLOT_DISPLAY_BY_DATE[dateYMD]) return PICKUP_SLOT_DISPLAY_BY_DATE[dateYMD].slice();
      return (day === 5 || day === 6) ? TIMESLOTS.weekend.slice() : TIMESLOTS.weekday.slice();
    }
    function renderTimeslots(date) {
      if (!timeslotWrap || !timeslotSection) return;
      const dateYMD = formatYMD(date);
      let slots = getSlotsForDate(date);
      slots = filterSlotsForAssorted(slots, date);
      if (timeInput) timeInput.value = '';
      timeslotSection.style.display = 'block';
      timeslotWrap.innerHTML = slots.map(function(slot) {
        const full = isTimeFullForCurrentProduct(dateYMD, slot);
        const cls = 'timeslot-btn' + (full ? ' timeslot-btn--full' : '');
        const disabledAttr = full ? ' disabled aria-disabled="true"' : '';
        return '<button type="button" class="' + cls + '" data-time="' + slot + '"' + disabledAttr + '>' +
          '<span class="timeslot-time">' + slot + '</span>' +
          (full ? ' <span class="timeslot-full-label">Full</span>' : '') +
          '</button>';
      }).join('');
      clearTimeslotUrgencyNote();
      const hasVisibleFullSlot = slots.some(function(slot) { return isTimeFullForCurrentProduct(dateYMD, slot); });
      if (hasVisibleFullSlot) {
        const note = document.createElement('p');
        note.className = 'hc-timeslot-urgency';
        note.textContent = 'Some pickup times are already full. Please choose another available pickup time.';
        timeslotWrap.insertAdjacentElement('afterend', note);
      }
    }
    if (timeslotWrap && !timeslotWrap.dataset.bound) {
      timeslotWrap.addEventListener('click', function(e) {
        const btn = e.target.closest('.timeslot-btn');
        if (!btn) return;
        if (btn.disabled || btn.classList.contains('timeslot-btn--full')) return;
        timeslotWrap.querySelectorAll('.timeslot-btn').forEach(function(b) { b.classList.remove('timeslot-btn--active'); });
        btn.classList.add('timeslot-btn--active');
        if (timeInput) timeInput.value = btn.dataset.time;
      });
      timeslotWrap.dataset.bound = 'true';
    }
    const cal = Object.create(window.HaruCalendar);
    cal.onSelect = function(date) {
      if (dateInput) dateInput.value = formatDate(date);
      if (dateDisplay) dateDisplay.textContent = formatDate(date);
      renderTimeslots(date);
    };
    cal.onClear = function() {
      if (dateInput) dateInput.value = '';
      if (dateDisplay) dateDisplay.textContent = '';
      clearTimeslots();
    };
    if (!isSameDay) { cal.init('#cal-wrap', { blackoutDates: blackoutDates, forceOpenDates: productForceOpenDates }); }

    /* ── Edit mode: pre-fill from URL params ─────────────────────────────── */
    if (!isSameDay) {
      var editParams = new URLSearchParams(window.location.search);
      var editDateStr  = editParams.get('edit_date');
      var editTimeStr  = editParams.get('edit_time');
      var editWriting  = editParams.get('edit_writing') || '';
      var editText     = editParams.get('edit_text') || '';
      var isEditMode   = !!editDateStr || !!editWriting;

      if (isEditMode) {
        // Change button label
        var addBtn = form.querySelector('.add-to-cart-btn');
        if (addBtn) { addBtn.textContent = 'Update Cart'; }

        // Pre-fill writing toggle
        if (writingToggle && editWriting.toLowerCase().indexOf('yes') !== -1) {
          writingToggle.checked = true;
          writingEnabled = true;
          if (writingField) writingField.style.display = 'block';
          if (writingInput) {
            writingInput.value = editText;
            var charCounter = document.getElementById('char-count');
            if (charCounter) charCounter.textContent = editText.length;
          }
          updateVariant();
          updatePrice();
        }

        // Pre-select calendar date
        if (editDateStr) {
          var preDate = parseEditDateString(editDateStr);
          if (preDate && isSelectable(preDate, blackoutDates, productForceOpenDates)) {
            cal.viewYear = preDate.getFullYear();
            cal.viewMonth = preDate.getMonth();
            cal.selectedDate = preDate;
            cal.render();
            cal.onSelect(preDate); // sets dateInput + renders timeslots
            // Dispatch change event so CYO block's fetchAvailability() also fires
            if (dateInput) dateInput.dispatchEvent(new Event('change'));

            // Pre-select time after timeslots have rendered
            if (editTimeStr) {
              setTimeout(function () {
                if (!timeslotWrap) return;
                var timeBtn = timeslotWrap.querySelector('[data-time="' + editTimeStr + '"]');
                if (timeBtn && !timeBtn.disabled && !timeBtn.classList.contains('timeslot-btn--full')) {
                  timeslotWrap.querySelectorAll('.timeslot-btn').forEach(function(b) {
                    b.classList.remove('timeslot-btn--active');
                  });
                  timeBtn.classList.add('timeslot-btn--active');
                  if (timeInput) timeInput.value = editTimeStr;
                }
              }, 0);
            }
          }
        }
      }
    }
    /* ── End edit mode ───────────────────────────────────────────────────── */

    const thumbs  = document.querySelectorAll('.thumb-btn');
    const mainImg = document.getElementById('main-product-img');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('thumb-btn--active'); });
        thumb.classList.add('thumb-btn--active');
        if (mainImg) mainImg.src = thumb.dataset.src;
      });
    });
    function getSelectedPickupDate() {
      if (cal.selectedDate) return cal.selectedDate;
      if (dateInput && dateInput.value) return parseDisplayDate(dateInput.value);
      return null;
    }
    function tryAddCandleViaAjax(e, form) {
      var candleCards = document.querySelectorAll('.candle-card[data-variant-id]');
      var candleItems = [];
      for (var i = 0; i < candleCards.length; i++) {
        var card = candleCards[i];
        var qtyEl = card.querySelector('.candle-card__qtyval');
        if (!qtyEl) continue;
        var qty = parseInt(qtyEl.getAttribute('data-qty') || '0', 10);
        if (qty <= 0) continue;
        candleItems.push({ id: card.getAttribute('data-variant-id'), quantity: qty });
      }
      if (!candleItems.length) return false;
      e.preventDefault();
      var fd = new FormData(form);
      var cakeVariantId = fd.get('id');
      var cakeQty = parseInt(fd.get('quantity') || '1', 10);
      var cakeProps = {};
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) cakeProps[m[1]] = v; });
      var btn = form.querySelector('.add-to-cart-btn');
      var origLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var items = [{ id: cakeVariantId, quantity: cakeQty, properties: cakeProps }].concat(candleItems);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (d) { throw new Error(d.description || d.message || 'Add to cart failed'); });
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = origLabel; }
        alert('Add to cart failed: ' + err.message + '\nOne of the candles may be out of stock. Adjust quantities and try again.');
      });
      return true;
    }
    form.addEventListener('submit', function(e) {
      if (isSameDayProduct(form)) {
        // Board lettering validation: require text if toggle is on, before 2 PM cutoff
        if (!isAfterLetteringCutoff() && writingEnabled && writingInput && !writingInput.value.trim()) {
          e.preventDefault(); alert('Please enter your cake board message before adding to cart.'); return;
        }
        // Persist board message as line item property
        if (writingEnabled && writingInput && writingInput.value.trim()) {
          setLineItemProperty(form, 'Board Message', writingInput.value.trim());
        }
        prepareSameDayPickup(form); tryAddCandleViaAjax(e, form); return;
      }
      const selectedDate = getSelectedPickupDate();
      if (!selectedDate) { e.preventDefault(); alert('Please select a pickup date.'); return; }
      if (!isSelectable(selectedDate, blackoutDates, productForceOpenDates)) { e.preventDefault(); alert('This pickup date is unavailable. Please choose another date.'); return; }
      if (!timeInput || !timeInput.value) { e.preventDefault(); alert('Please select a pickup time.'); return; }
      const selectedYMD = formatYMD(selectedDate);
      if (selectedYMD === '2026-05-26' && !isAssortedCakeProduct() && selectedSize && selectedSize.indexOf('6"') !== -1) { e.preventDefault(); alert('6-inch cakes are sold out for this pickup date. Please select 7-inch.'); return; }
      if (isTimeFullForCurrentProduct(selectedYMD, timeInput.value)) { e.preventDefault(); alert('This pickup time is now full. Please select a different time.'); return; }
      if (isAssortedCakeProduct()) {
        const minMinutes = assortedMinMinutesForDate(selectedDate);
        if (timeToMinutes(timeInput.value) < minMinutes) {
          e.preventDefault();
          alert(selectedDate.getDay() === 6
            ? 'Assorted Cake orders on Saturday require a pickup time of 1:00 PM or later. Please select a valid time.'
            : 'Assorted Cake orders require a pickup time of 12:00 PM or later. Please select a valid time.');
          return;
        }
      }
      if (!selectedSize && !isAssortedCakeProduct()) { e.preventDefault(); alert('Please select a cake size.'); return; }
      tryAddCandleViaAjax(e, form);
    });
    updatePrice();
  }

  /* ─────────────────────────────────────────
     HEADER / MOBILE NAV
     ───────────────────────────────────────── */
  function initHeader() {
    var toggle = document.querySelector('.mobile-nav-toggle');
    var nav    = document.querySelector('.header-nav');
    var siteHeader = document.querySelector('.site-header');
    if (!toggle || !nav) return;

    function openNav() {
      // Anchor nav to actual header bottom (accounts for announcement bar height)
      if (siteHeader) {
        nav.style.top = Math.round(siteHeader.getBoundingClientRect().bottom) + 'px';
      }
      nav.classList.add('header-nav--open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function closeNav() {
      nav.classList.remove('header-nav--open');
      nav.style.top = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function() {
      if (nav.classList.contains('header-nav--open')) { closeNav(); } else { openNav(); }
    });
    // Close mobile nav overlay when any nav link is tapped
    nav.querySelectorAll('.header-nav__link').forEach(function(link) {
      link.addEventListener('click', function() { closeNav(); });
    });
  }

  /* ─────────────────────────────────────────
     CART PAGE - quantity controls
     ───────────────────────────────────────── */
  function initCartPage() {
    document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const row = btn.closest('[data-cart-item]');
        if (!row) return;
        const input = row.querySelector('.cart-qty-input');
        if (!input) return;
        const delta = btn.classList.contains('cart-qty-plus') ? 1 : -1;
        const val = Math.max(0, parseInt(input.value || 1, 10) + delta);
        input.value = val;
        if (input.closest('form')) { input.closest('form').submit(); }
      });
    });
  }

  /* ─────────────────────────────────────────
     ANNOUNCEMENT BAR auto-dismiss
     ───────────────────────────────────────── */
  function initAnnouncement() {
    const bar   = document.querySelector('.announcement-bar');
    const close = document.querySelector('.announcement-close');
    if (!bar || !close) return;
    close.addEventListener('click', function() { bar.style.display = 'none'; });
  }

  /* ─────────────────────────────────────────
     INIT
     ───────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    initHeader();
    initProductPage();
    initCartPage();
    initAnnouncement();
  });

})();
